import React from 'react'
import './EmpMasterButton.css'

function EmpMasterButton(props) {
  return (
    <button data-testid={props.datatestid ? props.datatestid : "save-button"} style={{ background: props.background,color:props.color }} disabled={props.disabled} className='EmpMasterBtn' onClick={props.onClick}>{props.children}</button>
  )
}

export default EmpMasterButton